// MT: sepet cross-sell (blocks/mt-cart-upsell.liquid, WP3.4).
// - <mt-cart-upsell>: Shopify öneri uç noktasından (section_id=mt-cart-recommendations) kartları alır, en fazla N tane gösterir.
//   Öneri yoksa gizli kalır. Sepet değişince yeniden yüklenir (sepete eklenen ürün listeden düşer).
// - [data-mt-upsell-form]: tek tıkla ekleme. /cart/add.js + Horizon'un sepet olayıyla çekmece/sayfa yeniden çizilir.
// - Önbellek (QA tur1 pdp-10b): öneri HTML'i sepetteki (hediye olmayan) ürün kümesine bağlıdır (liste sepettekileri
//   eler). Küme değişmediyse (ör. hediye eşitlemesinin ikinci olayı) yeniden çekilmez. Küme bilinmiyorsa önbellek yok.
//   Sepette olan ürünün kartı (hediye ürünü dahil) istemcide de elenir.
import { StandardEvents, CartLinesUpdateEvent } from '@shopify/events';

const SOURCE = 'mt-upsell';
const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

/** @type {Map<string, Promise<string>>} */
const cache = new Map();
/** Son bilinen sepet: hediye olmayan ürün kümesi anahtarı ve sepetteki ürün tutamaçları. */
let cartKey = null;
let cartHandles = new Set();

function rememberCart(items) {
  if (!Array.isArray(items)) {
    cartKey = null;
    return;
  }
  cartKey = Array.from(
    new Set(items.filter((i) => !(i.properties && i.properties._mt_gift)).map((i) => String(i.product_id)))
  )
    .sort()
    .join(',');
  cartHandles = new Set(items.map((i) => i.handle).filter(Boolean));
}

function fetchHtml(url) {
  const key = cartKey === null ? null : url + '|' + cartKey;
  if (key && cache.has(key)) return cache.get(key);
  const request = fetch(url).then((response) => (response.ok ? response.text() : ''));
  if (key) {
    cache.set(key, request);
    request.catch(() => cache.delete(key));
  }
  return request;
}

function handleOf(card) {
  const href = card.querySelector('a[href]')?.getAttribute('href');
  if (!href) return '';
  const match = new URL(href, window.location.origin).pathname.match(/\/products\/([^/?#]+)/);
  return match ? decodeURIComponent(match[1]) : '';
}

class MtCartUpsell extends HTMLElement {
  #loading = null;

  connectedCallback() {
    this.load();
  }

  async load() {
    const url = this.dataset.url;
    if (!url || this.#loading) return;
    this.#loading = fetchHtml(url)
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const inner = doc.querySelector('.mt-upsell__inner');
        const max = Number(this.dataset.max) || 3;
        if (!inner) {
          this.replaceChildren();
          this.hidden = true;
          return;
        }
        let shown = 0;
        inner.querySelectorAll('.mt-upsell__card').forEach((card) => {
          if (shown >= max || cartHandles.has(handleOf(card))) card.remove();
          else shown++;
        });
        if (!shown) {
          this.replaceChildren();
          this.hidden = true;
          return;
        }
        const heading = inner.querySelector('.mt-upsell__heading');
        if (heading && this.dataset.heading) heading.textContent = this.dataset.heading;
        this.replaceChildren(document.importNode(inner, true));
        this.hidden = false;
      })
      .catch(() => {
        this.hidden = true;
      })
      .finally(() => {
        this.#loading = null;
      });
    return this.#loading;
  }
}

if (!customElements.get('mt-cart-upsell')) {
  customElements.define('mt-cart-upsell', MtCartUpsell);

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-mt-upsell-form')) return;
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    button?.setAttribute('aria-busy', 'true');
    const id = Number(new FormData(form).get('id'));
    const ids = Array.from(document.querySelectorAll('cart-items-component'))
      .map((el) => el instanceof HTMLElement && el.dataset.sectionId)
      .filter(Boolean);
    const deferred = CartLinesUpdateEvent.createPromise();
    try {
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: ids.join(','), sections_url: window.location.pathname }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || String(response.status));
      const cart = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      document.dispatchEvent(
        new CartLinesUpdateEvent({
          action: 'add',
          context: SOURCE,
          lines: [],
          promise: deferred.promise,
        })
      );
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { source: SOURCE, sections: data.sections || {}, itemCount: cart.item_count, items: cart.items },
      });
    } catch (error) {
      console.error('[mt-upsell] eklenemedi', error);
      // Yedek yol: native gönderim (sepet sayfasına gider).
      form.removeAttribute('data-mt-upsell-form');
      form.submit();
    } finally {
      button?.removeAttribute('aria-busy');
    }
  });

  document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
    (event.promise || Promise.resolve())
      .catch(() => {})
      .then((result) => {
        rememberCart(result && result.detail ? result.detail.items : null);
        // Horizon yeniden çizimi (morph) bittikten sonra öneriyi tazele.
        setTimeout(() => {
          document.querySelectorAll('mt-cart-upsell').forEach((el) => {
            if (el instanceof MtCartUpsell) el.load();
          });
        }, 60);
      });
  });
}
